// src/components/Supervisor/SupervisorForm.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { criarSupervisor } from '../../services/supervisorService';

/**
 * Formulário para cadastro de supervisor.
 * @param {Object} props
 * @param {Function} props.onSuccess Callback executado após cadastro bem-sucedido.
 */
const SupervisorForm = ({ onSuccess }) => {
  const [usuarioId, setUsuarioId] = useState('');
  const [areaEspecializacao, setAreaEspecializacao] = useState('');
  const [cargaMaxima, setCargaMaxima] = useState(5);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const payload = {
        usuario_id: Number(usuarioId),
        area_especializacao: areaEspecializacao.trim(),
        carga_maxima: Number(cargaMaxima)
      };

      await criarSupervisor(payload);
      onSuccess();

      // limpar campos
      setUsuarioId('');
      setAreaEspecializacao('');
      setCargaMaxima(5);
    } catch (err) {
      console.error('Erro ao cadastrar supervisor:', err);
      setError('Falha ao cadastrar supervisor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          ID do Usuário:
          <input
            type="number"
            placeholder="ID do Usuário"
            value={usuarioId}
            onChange={(e) => setUsuarioId(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      <div>
        <label>
          Área de Especialização:
          <input
            type="text"
            placeholder="Área de Especialização"
            value={areaEspecializacao}
            onChange={(e) => setAreaEspecializacao(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      <div>
        <label>
          Carga Máxima:
          <input
            type="number"
            placeholder="Carga Máxima"
            value={cargaMaxima}
            onChange={(e) => setCargaMaxima(e.target.value)}
            disabled={loading}
            required
            min={1}
          />
        </label>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" disabled={loading}>
        {loading ? 'Registrando...' : 'Registrar Supervisor'}
      </button>
    </form>
  );
};

SupervisorForm.propTypes = {
  onSuccess: PropTypes.func.isRequired
};

export default SupervisorForm;
